

export default class StatisticsManager {

    constructor(indexDbManager) {

        this.calculateZscore = this.calculateZscore.bind(this);
        this.calculateZVars = this.calculateZVars.bind(this);
        this.calculateMadVars = this.calculateMadVars.bind(this);
    }


    calculateZscore(dataSet, myData) {

        let count = dataSet.length;
        let total = 0;
        for (var i = 0; i < count; i++) {
            total += dataSet[i];
        }
        let average = total / count;
        let squareSum = 0;
        for (var i = 0; i < count; i++) {
            squareSum += (Math.pow(dataSet[i] - average, 2));
        }
        let standardDeviation = Math.sqrt(squareSum / (count - 1)).toFixed(4);

        let myZscore = null;
        if (myData != undefined) {
            myZscore = (myData - average) / standardDeviation;
        }
        let allZscores = [];
        for (var i = 0; i < count; i++) {
            allZscores.push((dataSet[i] - average) / standardDeviation);
        }

        return { allZscores: allZscores, myZscore: myData != undefined ? myZscore : undefined };
    }

    calculateZVars(startDataSet) {

        let dataSet = [];

        for (var i = 0; i < startDataSet.length; i++) {
            if (startDataSet[i] != 0) {
                dataSet.push(startDataSet[i]);
            }
        }

        let count = dataSet.length;
        let total = 0;
        for (var i = 0; i < count; i++) {
            total += dataSet[i];
        }
        let average = total / count;
        let squareSum = 0;
        for (var i = 0; i < count; i++) {
            squareSum += (Math.pow(dataSet[i] - average, 2));
        }
        let standardDeviation = Math.sqrt(squareSum / (count - 1)).toFixed(4);

        return { mean: average, standardDeviation: standardDeviation };
    }

    calculateModZScore(startDataSet, value, isUnder) {

        if (startDataSet === undefined || startDataSet === null) {
            return null;
        }

        let dataSet = [];
        let valueDataSet = [];
        for (var i = 0; i < startDataSet.length; i++) {
            if ((isNaN(startDataSet[i]) && startDataSet[i].value != 0) ||
                (!isNaN(startDataSet[i]) && startDataSet[i] != 0)) {
                dataSet.push(startDataSet[i]);
            }
            if (isNaN(startDataSet[i]) && startDataSet[i].value != 0) {
                valueDataSet.push(startDataSet[i].value);
            }
        }

        if (value != undefined) {
            let madVars = this.calculateMadVars(dataSet);
            return (madVars.constant * (value - madVars.median)) / madVars.MAD;
        } else {

            let madVars = this.calculateMadVars(valueDataSet);

            let resultSet = [];
            for (var i = 0; i < dataSet.length; i++) {
                let score = (madVars.constant * (dataSet[i].value - madVars.median)) / madVars.MAD;
                resultSet.push({ key: dataSet[i].key, location: dataSet[i].location, userId: dataSet[i].userId, value: isUnder ? -score : score });
            }
            resultSet = _.sortBy(resultSet, (obj) => { return obj.value });

            return resultSet;
        }
    }

    calculateMadVars(startDataSet) {
        let dataSet = [];

        for (var i = 0; i < startDataSet.length; i++) {
            if (startDataSet[i] != 0) {
                dataSet.push(startDataSet[i]);
            }
        }
        dataSet = _.sortBy(dataSet, (num) => { return num });

        let median = dataSet[Math.floor(dataSet.length / 2)];
        let meds = [];
        for (var i = 0; i < dataSet.length; i++) {
            meds.push(Math.abs(dataSet[i] - median));
        }
        meds = _.sortBy(meds, (num) => { return num });
        let MAD = meds[Math.floor(meds.length / 2)];

        return { MAD: MAD, median: median, constant: 0.6745 };
    }
}